import React, { useState, useEffect, useRef, useMemo } from "react";
import { fetchAPI } from "@/utility/NetworkUtils";
import OutlinedTable from "@/layouts/tables/OutlinedTable";
import { createRoot } from "react-dom/client";
import $ from "jquery";


import {
  getShippingColumns,
  getOnsiteColumns,
  getReturnsColumns,
  hasReturnedRowBeenAdjusted,
  MANIFEST_FLAG_FILTER_OPTIONS,
  itemMatchesManifestFlagFilter
} from "./ManifestTableUtils";
import ManifestReturnsModal from "./ManifestReturnsModal";
import { Button } from "@mui/material";
import { isJaguar } from "@/utility/UserUtils";
import { useConfirm } from 'material-ui-confirm';
import SuperFilter from "@/layouts/superfilter/SuperFilter";
import { isArray } from "jquery";
import TableToExcel from "@linways/table-to-excel";
import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";
import Loading from "@/shared/Loading";
const ShippingTable = ({
  event,
  type,
  user
}) => {

  const confirm = useConfirm();
  const [ items, setItems ] = useState([]);
  const [ itemHolds, setItemHolds ] = useState([]);
  const [ eventItemFields, setEventItemFields ] = useState([]);
  const [ loading, setLoading ] = useState(true);
  const [ superFilters, setSuperFilters ] = useState([]);
  useEffect(() => {
    loadHolds();
  },[]);

  const getSuperFilteredItems = (items) => {
    let filteredItems = items
    superFilters.forEach(filterObject =>{
      switch(filterObject.filterID){
        case "category":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            
            filteredItems = filteredItems.filter(item => {
              return filterObject.filterValue.includes((item.category||{group_name: "Other"}).group_name)
            });
          }
          break;
        case "location":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            filteredItems = filteredItems.filter(item => {
              const locations = (item.holds||[]).map(x=>x.location).filter(x=>x)
              const isAvailable = locations.map(location=> {
                console.log({
                  location,
                  y: filterObject.filterValue,
                  z: filterObject.filterValue.includes(location)
                })
                return filterObject.filterValue.includes(location)
              }).filter(x=>x).length > 0 
              console.log({
                isAvailable
              })
              return isAvailable
            });
          }
          break;
        case "subcategory":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){

            filteredItems = filteredItems.filter(item => filterObject.filterValue.includes((item.category||{}).name));
          }
          break;
        case "return-status":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            filteredItems = filteredItems.filter(item => filterObject.filterValue.includes(item.return_status));
          }
          break;
        case "shipping-status":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            
            filteredItems = filteredItems.filter(item => {
              for(let status of filterObject.filterValue) {
                if(item.holds.filter(x=>x.status == status).length > 0) {
                  return true
                }
              }
              return false
            });
          }
          break;
        case "flags":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            filteredItems = filteredItems.filter(item => itemMatchesManifestFlagFilter(item, filterObject.filterValue));
          }
          break;
        case "search":
          if(filterObject.filterValue && typeof filterObject.filterValue == "string"){
            filteredItems = filteredItems.filter(item => (item.name||"").toLowerCase().includes((filterObject.filterValue||"").toLowerCase()));
          }
          break;
        default:
          break;
      }
    })
    return filteredItems
  }

  const loadHolds = async () => {
    fetchAPI(`/webapi/events/${event.id}/manifest/shipping`, (json)=> {
      if (!json.errors) {
        setItems(json.items)
        setItemHolds(json.item_holds)
        setEventItemFields(json.event_item_fields)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }

    });
  }

  const getColumns = () => {
    switch(type) {
      case "shipping":
        return getShippingColumns()
      case "onsite":
        return getOnsiteColumns()
      case "returns":
        return getReturnsColumns()
      default:
        return []
    }
  }

  const columns = useMemo(() => {
    return getColumns()
  },[type])

  const pendingEIFChanges = useRef({});
  const debounceEIFTimers = useRef({});

  
const updateEventItemField = async (id, changes = {}) => {
  const field = eventItemFields.find(x=>x.id == id)
  const item = items.find(x=>x.id == field.item_id)

  if(item) {
    item.changed_at = true
  }
  if (field) {
    setEventItemFields((prevFields) => 
      prevFields.map((f) => 
        f.id === id ? {...field, ...changes} : f
      )
    );
  }

  pendingEIFChanges.current[id] = {
    ...pendingEIFChanges.current[id],
    ...changes
  }
  if(debounceEIFTimers.current[id]) {
    clearTimeout(debounceEIFTimers.current[id]);
  }

  debounceEIFTimers.current[id] = setTimeout(() => {
    fetchAPI(`/events/${event.id}/event_item_fields/${id}`,()=> {

    },
    {
      method: "PATCH",
      body: {...changes},
    })
    pendingEIFChanges.current[id] = null
  }, 500);
}
  

const pendingHoldChanges = useRef({});
const debounceHoldTimers = useRef({});

  const mapItem = (x, palletOptions = []) => {
    if(x.changed_at) {
      x = {...x}
    }
    x.changed_at = false
    x.holds = itemHolds.filter(y=>y.item_id == x.id).map(x=> {
      x.updateItemHold = updateItemHold
      return x
    })

    x.disabled_input = isInputDisabled
    x.reserved_holds = x.holds.filter(x=> !x.direct_to_site)
    x.direct_to_site_holds = x.holds.filter(x=> x.direct_to_site)
    x.reserved = x.reserved_holds.map(x=>x.total_count).reduce((a,b)=>a+b,0)
    x.total_count_including_filtered_items = x.holds.map(x=>x.total_count).reduce((a,b)=>a+b,0)
    x.direct_to_site = x.direct_to_site_holds.map(x=>x.total_count).reduce((a,b)=>a+b,0)
    x.order_not_finalized_holds = x.holds.filter(x=> x.order_not_finalized)
    x.order_not_finalized = x.order_not_finalized_holds.map(x=>1).reduce((a,b)=>a+b,0)
    x.owner = (x.renter||{name: "Jaguar"}).name
    x.event_item_fields = eventItemFields.find(eif=> eif.item_id == x.id)||{}
    x.event = event
    x.setItems = setItems
    x.updateItemHold = updateItemHold
    x.updateEventItemField = updateEventItemField
    x.openManifestReturnsModal =openManifestReturnsModal
    x.palletOptions = palletOptions
    x.return_status = "none-returned"

    if(x.event_item_fields.warehouse_received > 0) {
      x.return_status = "partial-returned"
    }

    if(x.event_item_fields.warehouse_received >= x.holds.map(x=> x.total_packed).reduce((a, b) => a + b, 0)) {
      x.return_status = "all-returned"
    }
    if(!hasReturnedRowBeenAdjusted(x.event_item_fields)) {
      x.return_status = "return-not-started"
    }
    return x
  }

  const updateItemHold = async (id, changes = {}) => {
    const hold = itemHolds.find(x=>x.id == id)
    const changesToPost = {...changes}
    item = items.find(x=>x.id == hold.item_id)
    if(item) {
      item.changed_at = true
    }
    if(changes['status'] && changes['status'] != 'reserved') {
      changes['locked'] = true
      changesToPost['locked'] = true
    }
    if(changes['pallet']) {
      changes['pallet']={id: null, name: changes['pallet']}
    }
    if(changes['status'] == 'shipped') {
      if(hold['total_packed'] == null) {
        changesToPost['total_packed'] = hold['total_count']

        hold['total_packed'] = hold['total_count']
      }
    }
    if (hold) {
      //setItemHolds([...itemHolds])
      setItemHolds((prevHolds) => 
        prevHolds.map((h) => 
          h.id === id ? {...hold, ...changes} : h
        )
      );
      pendingHoldChanges.current[id] = {
        ...pendingHoldChanges.current[id]||{},
        ...changesToPost
      }
      if(debounceHoldTimers.current[id]) {
        clearTimeout(debounceHoldTimers.current[id]);
      }

      debounceHoldTimers.current[id] = setTimeout(() => {
        fetchAPI(`/events/${event.id}/item_holds/${id}`,(json)=> {
          if(json.error) {
            alert("It appears there was an error updating this item. Please try again, or contact an admin if the problem persists.")
          }
        },
        {
          method: "PATCH",
          body: {...pendingHoldChanges.current[id]},
          onError: (err) => {
            alert("It appears there was an error updating this item. Please try again, or contact an admin if the problem persists.")
          }
        })
        pendingHoldChanges.current[id] = null
      }, 500);
    }
  }

  const openManifestReturnsModal = (item_id) => {
    setOpenManifestReturnsModalId(item_id)
  }

  const isInputDisabled = !(type == "onsite" || isJaguar(user))

  const getData = () => {

    const palletOptions = itemHolds.map(x=>(x.pallet||{}).name).filter(x=>x).filter((x,i,a)=>a.indexOf(x) == i).map(x=>({label: x, value: x}))
    let mappedItems = items.map(x=>{
      return mapItem(x, palletOptions)
    })
    mappedItems = getSuperFilteredItems(mappedItems)
    return mappedItems
  }

  const data = useMemo(() => {
    return getData()
  }, [items, itemHolds, eventItemFields, user, superFilters])


  const [openManifestReturnsModalId, setOpenManifestReturnsModalId] = useState(null)

  const renderFinalizeReturn = () => {
    if(isJaguar(user)){
      if(event.manifest_return_completed_at) {
        return (
          <div className="mb-3 float-right">
            Manifest Return Finalized at {new Date(event.manifest_return_completed_at).toLocaleString('en-US')}
          </div>
        )
      } else {
        return (
          <div className="mb-3 float-right">
            <button
              className="btn-outlined mr-4 btn-filled"
              onClick={finalizeReturn}
            >
              FINALIZE RETURN
            </button>
          </div>
        );
      }
    }
  }

  const finalizeReturn = async () => {
    const unfinalizedRows = data.filter(x=>
      !hasReturnedRowBeenAdjusted(x.event_item_fields)
    )

    if(unfinalizedRows.length != 0) {
      alert("Please finish returning all items before Finalizing. Even items that recieved 0 need to be marked with damaged counts.")
      return
    }
    const { confirmed, reason } = await confirm({
      description: "Are you sure you want to finalize this events return? This cannot be undone and will add all returned items back to the catalog.",
      confirmationText: "Finalize Return",
      cancellationText: "Cancel",
    });
    if(confirmed) {
      fetchAPI(`/webapi/events/${event.id}/manifest/finalize_return`, (json)=> {
        if (!json.errors) {
          //Reload Window
          window.location.reload()
        } else {
          alert(json.error)
        }
      },
      {
        method: "POST",
        body: {
          
        }
      })
    }
  }

  renderSuperfilter = () => {
    return (
      <SuperFilter
        urlLock={true}
        search={false}
        disableLabel={true}
        onChange={(filters) => {
          setSuperFilters(filters)
        }}
        id={`shipping-table-superfilter-${type}`}
        lockable
        filters={getSuperFilters()}
      />
    )
  }

  getSuperFilters = () => {
    return [
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "category",
        type:"multiselect",
        options: items.map(item => {
            const category = item.category
            return category ? {value: category.group_name, id: category.group_name, label: category.group_name} : null
        }).filter(x=>
          x
        ).filter((x,i,t)=> {
          return t.map(y=>y.value).indexOf(x.value) === i
        }).concat(
          [{value: "Other", id: "Other", label: "Other"}]
        ).sort((a, b) => a.label.localeCompare(b.label)),
        placeholder: "Category",
        name: "Category"
      },
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "subcategory",
        type:"multiselect",
        options: items.map(item => {
            const category = item.category
            return category ? {value: category.name, id: category.name, label: category.name} : null
        }).filter(x=>x).filter((x,i,t)=> t.map(x=>x.value).indexOf(x.value) === i),
        placeholder: "Subcategory",
        name: "Subcategory"
      },
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "return-status",
        type:"multiselect",
        options: [
          {value: "return-not-started", id: "return-not-started", label: "Return Not Started"},
          {value: "all-returned", id: "all-returned", label: "All Returned"},
          {value: "partial-returned", id: "partial-returned", label: "Partial Return"},
          {value: "none-returned", id: "none-returned", label: "None Returned"},
        ],
        placeholder: "Status",
        name: "Status",
        hidden: type != "returns"
      },
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "location",
        type:"multiselect",
        options: itemHolds.map(x => {
          return {
            value: x.location,
            label: x.location,
            id: x.location
          }
        }).filter(x=>
          x && x.value
        ).filter((x,i,t)=> {
          return t.map(y=>y.value).indexOf(x.value) === i
        }).sort((a, b) => a.label.localeCompare(b.label)),
        placeholder: "Location",
        name: "Dist. Location",
        hidden: type == "returns"
      },
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "shipping-status",
        type:"multiselect",
        options: [
          {value: "received", id: "received", label: "Received"},
          {value: "shipped", id: "shipped", label: "Shipped"},
          {value: "packed", id: "packed", label: "Packed"},
          {value: "in_progress", id: "in_progress", label: "In Progress"},
          {value: "reserved", id: "reserved", label: "Reserved"},
        ],
        placeholder: "Status",
        name: "Status",
        hidden: type != "shipping"
      },
      {
        outerClassName: "sg-super-filter-select-field-option-spacing",
        id: "flags",
        type:"multiselect",
        options: MANIFEST_FLAG_FILTER_OPTIONS,
        placeholder: "Flags",
        name: "Flags"
      },

      // {
      //   outerClassName: "sg-super-filter-select-field-option-spacing",
      //   id: "subcategory",
      //   type:"multiselect",
      //   options: 
      //     this.props.categories.map(category => {
      //       return {value: category.name, id: category.name, label: category.name}
      //     })
      //   ,
      //   placeholder: "Subcategory",
      //   name: "Subcategory"
      // },
      {
        id: "search",
        type:"search",
        options: [],
        outerClassName: "sg-super-filter-search-field-option-spacing",
        placeholder: "Search",
        name: "Search"
      },
      
    ].filter(x=>!x.hidden)
  }

  const downloadReport = () => {

    const container = document.createElement("div");
    document.body.appendChild(container);
      const root = createRoot(container);
    // Mount component
    root.render(
      <OutlinedTable 
        exportable={true}
        tableId="shipping-table"
        loading={loading}
        defaultSortBy={`item`}
        defaultSortByDirection="asc"
        columns={columns}
        rows={data}
        exportOnly={true}
      />
    );
    requestAnimationFrame(() => {
      TableToExcel.convert(document.getElementById("shipping-table-export"), {
        name: "manifest.xlsx",
        sheet: {
          name: "Sheet 1"
        }
      });
      // Unmount component
      root.unmount();
      container.remove();
    });
  }

  return (
    <>
 
    <ManifestReturnsModal
      item_id={openManifestReturnsModalId}
      row={data.find(x=>x.id == openManifestReturnsModalId)}
      open={!!openManifestReturnsModalId}
      closeModal={() => {
        const item = data.find(x=>x.id == openManifestReturnsModalId)
        data.changed_at = true
        setOpenManifestReturnsModalId(null)
      }}
    />
    {
        type == "returns" ? renderFinalizeReturn() : ""
    }
    {renderSuperfilter()}
    {!loading && (
      <button
        type="button"
        className="btn-outlined mr-4 btn-filled" 
        onClick={downloadReport}

      >
        Export to Excel
      </button>
    )}

    {loading ? <Loading /> : (
      <OutlinedTable
        tableId="shipping-table"
        loading={loading}
        defaultSortBy={`item`}
        defaultSortByDirection="asc"
        columns={columns}
        rows={data}
      />
    )}

    </>
  );

}

export default ShippingTable